import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import BrandLoader from '../feedback/BrandLoader';

function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();

  if (loading) {
    return <BrandLoader />;
  }

  if (!user) {
    return <Navigate to="/" replace />;
  }

  return children;
}

export default ProtectedRoute;
